import { addPageAction } from '@nike/ux-tread-new-relic';
import getSegmentInstance from './get-segment-instance';
import getSegmentWriteKey from './get-segment-write-key';
import segmentSchemaLookup from './segmentSchemaLookup';

/**
 * Fire a segment track event + NR page action directly, bypassing the Redux analytics middleware.
 * Mirrors the behavior of the NR sink (addPageAction) + segment sink (seg.track) in the engine.
 *
 * @param {object} params
 * @param {string} params.eventName - The segment event name (e.g., 'Join Clicked')
 * @param {object} [params.properties] - Event properties to send
 * @param {string} [params.$schema] - Optional schema override; falls back to segmentSchemaLookup
 */
export const trackSegmentEvent = ({ eventName, properties = {}, $schema }) => {
  addPageAction(eventName, properties);

  const segment = getSegmentInstance();
  const writeKey = getSegmentWriteKey();

  if (typeof segment.track === 'function') {
    segment.track(
      eventName,
      { eventName, ...properties },
      {
        $schema: $schema || segmentSchemaLookup[eventName],
        writeKey,
      },
    );
  }
};
